'use client';

import { ComponentProps, useMemo } from 'react';
import { useSelector } from 'react-redux';
import logWebHeaderAllTrailsLogoTapped from '@alltrails/amplitude/events/logWebHeaderAllTrailsLogoTapped';
import useMediaQuery from '@alltrails/core/hooks/useMediaQuery';
import Link from '@alltrails/denali/components/Link';
import Logo from '@alltrails/denali/components/Logo';
import { BREAKPOINT_MD_SIZE } from '@alltrails/denali/tokens';
import styles from './styles/styles.module.scss';
import { HeaderBackground } from './types';

type LogoLinkProps = {
  background?: HeaderBackground;
  logoColorOverride?: ComponentProps<typeof Logo>['color'];
  logoVariantOverride?: ComponentProps<typeof Logo>['variant'];
};

const LogoLink = ({ background, logoColorOverride, logoVariantOverride }: LogoLinkProps) => {
  const isMobileBrowser = useSelector((state: { context: { mobileBrowser: boolean } }) => state.context?.mobileBrowser);
  const isSmallerScreen = useMediaQuery(`(max-width: ${BREAKPOINT_MD_SIZE}px)`, isMobileBrowser);

  const logoProps = useMemo<Pick<ComponentProps<typeof Logo>, 'color' | 'variant'>>(() => {
    const color = logoColorOverride ?? (background === 'transparent-inverted' ? 'colored-light' : 'colored-dark');
    if (isMobileBrowser || isSmallerScreen) {
      return {
        color,
        variant: logoVariantOverride ?? 'symbol'
      };
    }
    return {
      color,
      variant: logoVariantOverride ?? 'logomark'
    };
  }, [background, isMobileBrowser, isSmallerScreen, logoColorOverride, logoVariantOverride]);

  return (
    <div className={styles.focusContainer}>
      <Link
        className={styles.logoLink}
        href="/"
        onClick={() => {
          logWebHeaderAllTrailsLogoTapped();
        }}
      >
        <Logo {...logoProps} size="sm" />
      </Link>
    </div>
  );
};
export default LogoLink;
